import { render, staticRenderFns } from "./ModalUploadEmployeePhoto.vue?vue&type=template&id=654d5503&scoped=true&"
import script from "./ModalUploadEmployeePhoto.vue?vue&type=script&lang=js&"
export * from "./ModalUploadEmployeePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d5503",
  null
  
)

export default component.exports